import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway'
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseTimezone from '../../AbstractObjects/GatewayPlan/InnerPages/BaseTimezone';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {timeZoneIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.timezone;
const pageId = pageSchema.pageId;

function GatewayTimezone({
    gatewayObject,
    planObject,
    setGatewayData,
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.localTimeZone], planPage[pageSchema.localTimeZone]);
            setGatewayData([pageId, pageSchema.daylightSavings], planPage[pageSchema.daylightSavings]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.TIME_ZONE')}
            icon={timeZoneIcon}
        >
            <BaseTimezone
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.DateAndTime')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.PLAN.NEW_PLAN_DS.NTP.AG_DATE_AND_TIME')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayTimezone;